/// <amd-module name="TFS/Admin/Groups/Common/Redux/DataSource/AdminTeamsDataSource" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

const AdminTeamsDataProvider = "ms.vss-admin-web.admin-teams-data-provider";
const TeamAdminListDataProvider = "ms.vss-admin-web.admin-teams-admin-list-data-provider";

export function updateTeamProperties(pageContext: IVssPageContext, requestParameters?: { [key: string]: any }): Promise<any> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    return contributionService.getDataAsync<any>(AdminTeamsDataProvider, requestParameters, true).then(result => {
        return result;
    });
}

export function getTeamAdmins(pageContext: IVssPageContext, descriptor: string): Promise<any> {
    const service = pageContext.getService<IVssContributionService>("IVssContributionService");
    return service.getDataAsync<any>(TeamAdminListDataProvider, { descriptor }, true).then(result => result);
}